module.exports = __webpack_public_path__ + "static/resource-1-c3ba3a3e68655915ac2e9190bd68a6c2.png";